import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '@/integrations/supabase/client';

type FutureRole = 'owner' | 'agent';

interface FutureRoleUser {
  role: FutureRole;
  firstName: string | null;
}

const ComingSoon = () => {
  const { t } = useTranslation();
  const [futureRoleUser, setFutureRoleUser] = useState<FutureRoleUser | null>(null);

  useEffect(() => {
    const load = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from('users')
        .select('role, first_name')
        .eq('auth_id', user.id)
        .maybeSingle();
      if (data?.role === 'owner' || data?.role === 'agent') {
        setFutureRoleUser({ role: data.role, firstName: data.first_name ?? null });
      }
    };
    load();
  }, []);

  if (futureRoleUser) {
    const greetingKey = futureRoleUser.firstName
      ? 'coming_soon.future_role_greeting_named'
      : 'coming_soon.future_role_greeting';
    return (
      <div className="flex min-h-[calc(100svh-var(--app-header-h,57px))] items-center justify-center bg-background px-4">
        <div className="text-center space-y-6 max-w-md">
          <div className="text-6xl" role="img" aria-label="waving hand">👋</div>
          <h1
            className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {t(greetingKey, { name: futureRoleUser.firstName ?? '' })}
          </h1>
          <p className="text-base text-muted-foreground">
            {t(`coming_soon.${futureRoleUser.role}_body`)}
          </p>
          <p className="text-sm text-muted-foreground/80">
            {t('coming_soon.future_role_contact_note')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-[calc(100svh-var(--app-header-h,57px))] items-center justify-center bg-background px-4">
      <div className="text-center space-y-6 max-w-md">
        <div className="text-6xl" role="img" aria-label="waving hand">👋</div>
        <h1
          className="text-4xl font-bold tracking-tight text-foreground"
          style={{ fontFamily: 'var(--font-heading)' }}
        >
          Flat Hero
        </h1>
        <p className="text-lg text-muted-foreground">
          {t('coming_soon.subtitle')}
        </p>
        <p className="text-sm text-muted-foreground/60">
          {t('coming_soon.tagline')}
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
